import React, { useMemo } from "react";
import Select from "../../../../shared/Select";
import Button from "../../../../shared/Button";
import swal from "sweetalert";
import { Tooltip } from "@mui/material";

const ConfigureRubricsBasedAssessment = ({
  assessmentScale,
  rubricsConfig,
  setRubricsConfig,
  CustomOption,
  CustomSingleValue,
  setConfigureRubricsAssessmentModal,
  selectedRow,
  setSelectedRow,
  setDeletedItem,
}) => {
  const options = useMemo(() => {
    if (!assessmentScale) return [];
    return assessmentScale?.assessmentScaleLevels?.map((item) => ({
      label: item?.level,
      value: item?.id,
      levelType: item?.levelType,
    }));
  }, [assessmentScale]);

  const handleAddRow = () => {
    const newRow = {
      name: "",
      desc: "",
    };

    setRubricsConfig((prev) => ({
      ...prev,
      [selectedRow]: [...(prev[selectedRow] || []), newRow],
    }));
  };

  const handleRemoveRow = (index, id) => {
    const newData = rubricsConfig[selectedRow]?.filter(
      (_, idx) => idx !== index,
    );

    setRubricsConfig((prev) => ({
      ...prev,
      [selectedRow]: newData,
    }));

    if (id) {
      setDeletedItem((prev) => ({
        ...prev,
        deleteRubricsIds: [...prev.deleteRubricsIds, id],
      }));
    }
  };

  const handleChange = (e, index) => {
    const { name, value } = e.target;

    if (
      value?.trim() &&
      rubricsConfig[selectedRow]?.some(
        (dt, i) =>
          i !== index &&
          dt?.name?.trim()?.toLowerCase() === value?.trim()?.toLowerCase(),
      )
    ) {
      swal("Oops", `${value} has already been configured`);
      return;
    }

    const updated = rubricsConfig[selectedRow].map((item, i) =>
      i === index ? { ...item, [name]: value } : item,
    );

    setRubricsConfig((prev) => ({
      ...prev,
      [selectedRow]: updated,
    }));
  };

  return (
    <>
      <div className="arr-table-container">
        <table className="arr-table">
          <thead>
            <tr>
              <th>Rubrics Name</th>
              <th>Description</th>
              <th>Preview</th>
            </tr>
          </thead>
          <tbody>
            {rubricsConfig[selectedRow]?.length > 0 ? (
              rubricsConfig[selectedRow]?.map((item, index) => (
                <tr key={index}>
                  <td>
                    <input
                      type="text"
                      name="name"
                      value={item?.name}
                      placeholder="Enter rubrics name"
                      className="form-control"
                      onChange={(e) => handleChange(e, index)}
                    />
                  </td>
                  <td>
                    <input
                      type="text"
                      name="desc"
                      value={item?.desc}
                      placeholder="Enter description"
                      className="form-control"
                      onChange={(e) => handleChange(e, index)}
                    />
                  </td>
                  <td>
                    <Select
                      options={options}
                      styles={{ control: { minWidth: "200px" } }}
                      components={{
                        Option: CustomOption,
                        SingleValue: CustomSingleValue,
                      }}
                      isClearable={false}
                    />
                  </td>
                  <td>
                    <Tooltip
                      title={
                        item?.recorded
                          ? "You cannot remove this rubrics because students mark have already been recorded."
                          : ""
                      }
                    >
                      <div>
                        <Button
                          onClick={() => handleRemoveRow(index, item?.id)}
                          size="sm"
                          variant="danger"
                          disabled={item?.recorded}
                        >
                          Remove
                        </Button>
                      </div>
                    </Tooltip>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td style={{ textAlign: "center" }} colSpan={3}>
                  No Configuraton Found
                </td>
              </tr>
            )}
          </tbody>
        </table>
        <div style={{ marginTop: "16px" }} className="action-btns end">
          <Button size="sm" onClick={handleAddRow}>
            Add Row
          </Button>
        </div>
      </div>

      <div className="action-btns end">
        {/* <Button
          onClick={() => {
            setConfigureRubricsAssessmentModal(false);
            setRubricsConfig((prev) => ({
              ...prev,
              [selectedRow]: [{ rubricsConfig: "", description: "" }],
            }));
            setSelectedRow(null);
          }}
          variant="outline"
        >
          Cancel
        </Button> */}
        <Button
          onClick={() => {
            setConfigureRubricsAssessmentModal(false);
            setSelectedRow(null);
          }}
        >
          Save
        </Button>
      </div>
    </>
  );
};

export default ConfigureRubricsBasedAssessment;
